import { ShowColumnsFilter } from "@/components/ColumnMenu";
import {
  ActionCellPopupSettings,
  ToggleCompanyActiveCell,
} from "@/components/custom-cells";
import { IUser } from "@/interfaces/user.interface";
// import { ObjectTypeActionCellPopup, SubContractorActionCellPopup } from "../../shared-components/custom-cells";
import { MIN_RESIZABLE_WIDTH_KENDO_TABLE } from "@/utils/kendo";

export interface columnInterface {
  title?: string;
  field?: string;
  show?: boolean;
  filter?: "boolean" | "numeric" | "text" | "date" | undefined;
  minWidth?: number;
  minGridWidth?: number;
  locked?: boolean;
  width?: string | number;
  columnMenu?: any;
  minResizableWidth?: number;
  cells?: any;
}

export const generateColumns = (
  handleEditClick: any,
  onColumnsSubmit: any,
  columnsExternal?: any,
  enableDisableUser?: (dataItem: IUser) => void,
  selectedProjectId?: string
): any => {
  const columns = [
    {
      title: "Name",
      field: "name",
      show: true,
      columnMenu: (props: any) => (
        <ShowColumnsFilter
          {...props}
          columns={columns || columnsExternal}
          onColumnsSubmit={onColumnsSubmit}
          showColumnMenu={true}
        />
      ),
      cells: {
        data: (props: any) => (
          <ActionCellPopupSettings
            rowData={props.dataItem}
            handleEditClick={handleEditClick}
            dataKey="name"
          />
        ),
      },
      minResizableWidth: MIN_RESIZABLE_WIDTH_KENDO_TABLE,
    },
    {
      title: "Email",
      field: "email",
      show: true,
      columnMenu: (props: any) => (
        <ShowColumnsFilter
          {...props}
          columns={columns || columnsExternal}
          onColumnsSubmit={onColumnsSubmit}
          showColumnMenu={true}
        />
      ),
      minResizableWidth: MIN_RESIZABLE_WIDTH_KENDO_TABLE,
    },
    {
      title: "Company",
      field: "companyName",
      show: true,
      columnMenu: (props: any) => (
        <ShowColumnsFilter
          {...props}
          columns={columns || columnsExternal}
          onColumnsSubmit={onColumnsSubmit}
          showColumnMenu={true}
        />
      ),
      minResizableWidth: MIN_RESIZABLE_WIDTH_KENDO_TABLE,
    },
    // {
    //   title: "Project",
    //   field: "projectName",
    //   show: true,
    //   columnMenu: (props: any) => (
    //     <ShowColumnsFilter
    //       {...props}
    //       columns={columns || columnsExternal}
    //       onColumnsSubmit={onColumnsSubmit}
    //       showColumnMenu={true}
    //     />
    //   ),
    //   minResizableWidth: MIN_RESIZABLE_WIDTH_KENDO_TABLE,
    // },
    {
      title: "Role",
      field: "roles",
      show: true,
      columnMenu: (props: any) => (
        <ShowColumnsFilter
          {...props}
          columns={columns || columnsExternal}
          onColumnsSubmit={onColumnsSubmit}
          showColumnMenu={true}
        />
      ),
      cells: {
        data: (props: any) => (
          <td>
            {props.dataItem.roles.map((role: string, index: number) => {
              return (
                <span key={index} className="text-xs font-normal">
                  {role}
                  {index !== props.dataItem.roles.length - 1 ? ", " : ""}
                </span>
              );
            })}
          </td>
        ),
      },
      minResizableWidth: MIN_RESIZABLE_WIDTH_KENDO_TABLE,
    },
    {
      title: "Last Login Date",
      field: "lastLoginDate",
      show: true,
      filter: "date",
      columnMenu: (props: any) => (
        <ShowColumnsFilter
          {...props}
          columns={columns || columnsExternal}
          onColumnsSubmit={onColumnsSubmit}
          showColumnMenu={true}
        />
      ),
      cells: {
        data: (props: any) => {
          const { lastLoginDate } = props.dataItem;
          if (!lastLoginDate) {
            return <td>-</td>;
          }
          const date = new Date(lastLoginDate);
          const formattedDate = date.toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
          });
          const formattedTime = date.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
          });
          return <td>{`${formattedDate}, ${formattedTime}`}</td>;
        },
      },
      minResizableWidth: MIN_RESIZABLE_WIDTH_KENDO_TABLE,
    },
    {
      title: "Active",
      field: "isActive",
      show: true,
      columnMenu: (props: any) => (
        <ShowColumnsFilter
          {...props}
          columns={columns || columnsExternal}
          onColumnsSubmit={onColumnsSubmit}
          showColumnMenu={true}
        />
      ),
      cells: {
        data: (props: any) => {
          const isActiveInProject = props.dataItem.projects?.some(
            (p: any) => p.id === selectedProjectId && p.isActive
          ) ?? false;
          return (
            <ToggleCompanyActiveCell
              {...props}
              dataItem={{ ...props.dataItem, isActive: isActiveInProject }}
              enableDisable={enableDisableUser}
              disabeled={false}
            />
          );
        },
      },
      minResizableWidth: MIN_RESIZABLE_WIDTH_KENDO_TABLE,
    },
  ];

  return columns;
};
